import { render, staticRenderFns } from "./formio-form.vue?vue&type=template&id=69fbc89a&"
import script from "./formio-form.vue?vue&type=script&lang=ts&"
export * from "./formio-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports